import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=21e696b3&scoped=true"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e696b3",
  null
  
)

export default component.exports